export const getOSType = (): string => {
    const userAgent =
        navigator.userAgent ||
        navigator.vendor ||
        (window as Window & { opera?: string }).opera ||
        ''

    if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone'
    }
    if (/win/i.test(userAgent)) {
        return 'Windows'
    }
    if (/mac/i.test(userAgent) && !/iphone|ipad|ipod/i.test(userAgent)) {
        return 'MacOS'
    }
    if (/android/i.test(userAgent)) {
        return 'Android'
    }
    if (/iphone|ipad|ipod/i.test(userAgent)) {
        return 'iOS'
    }
    if (/linux/i.test(userAgent)) {
        return 'Linux'
    }

    return 'Other'
}
